import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { DatePickerModel } from '../models/DatePickerModel';

const MONTHS_AR = ['محرم', 'صفر', 'ربيع الأول', 'ربيع الآخر', 'جمادى الأولى', 'جمادى الآخرة', 'رجب', 'شعبان', 'رمضان', 'شوال', 'ذو القعدة', 'ذو الحجة'];

const MONTHS_EN = ['Muharram', 'Safar', 'Rabi\'ul-Awwal', 'Rabi\'ul-Akhir', 'Jumadal-Ula', 'Jumadal-Akhir', 'Rajab', 'Sha\'ban', 'Ramadan', 'Syawwal', 'Dhul-Qa\'da', 'Dhul-Hijja'];

const language = localStorage.getItem('language') || 'en';

@Pipe({
  name: 'DateModel'
})
export class DateModelPipe implements PipeTransform {
  transform(date: DatePickerModel|any, time: string|null = null): string {
    if (!date) { return ''; }
    const months = language === 'en' ? MONTHS_EN : MONTHS_AR;

    let result = '';
    if (date.gregorianDate) {
      if (date.gregorianDate) {
        result += new DatePipe(language).transform(date.gregorianDate, 'd MMM, y');
      }
      if (date.gregorianDate && date.hijri) {
        result += ' - ';
      }
      if (date.hijri) {
        result += date.hijri.day + ' ' + months[date.hijri.month - 1] + ', ' + date.hijri.year;
      }
    } else {
      if (date.isHijri) {
        result += date.day + ' ' + months[date.month - 1] + ', ' + date.year;
      } else {
        result += date.day + ' ' + date.month + ', ' + date.year;
      }
    }

    if (time) {
      result +=
        new DatePipe(language)
          .transform(String(date.gregorianDate).split('T')[0] + ' ' + time, ' - h:mm a');
    }

    return result;
  }
}
